const local = {

    en:{
    msg:"You have no registered devices.",
    reged:"Registered devices: ",
    data:"Purchase date",
    warranty:"Warranty expires on",
    pcs:"pcs.",

    },

    ru:{
    msg:"У вас нет зарегистрированных приборов.",
    reged:"Зарегистрировано приборов: ",
    data:"Дата покупки",
    warranty:"Гарантия до",
    pcs:"шт.",

    },

    de:{
    msg:"Sie haben keine Geräte registriert.",
    reged:"Anzahl registrierter Geräte: ",
    data:"Kaufdatum",
    warranty:"Garantieleistung bis",
    pcs:"Stk.",

    },

};

export default local;